import { cn } from 'lib/utils';

export const PROJECT_COLORS = [
  { id: 'grey', value: '#BDBDBD' },
  { id: 'green', value: '#34C759' },
  { id: 'teal', value: '#2EC4B6' },
  { id: 'sky', value: '#5AC8FA' },
  { id: 'blue', value: '#007AFF' },
  { id: 'pink', value: '#FF2D55' },
  { id: 'orange', value: '#FF9500' },
  { id: 'purple', value: '#AF52DE' },
] as const;

export const DEFAULT_PROJECT_COLOR = PROJECT_COLORS[0].value;

interface ProjectColorSwatchesProps {
  selectedColor: string;
  onSelect: (color: string) => void;
}

export function ProjectColorSwatches({
  selectedColor,
  onSelect,
}: Readonly<ProjectColorSwatchesProps>) {
  return (
    <div className="flex w-full flex-wrap items-center gap-2 sm:gap-3">
      {PROJECT_COLORS.map((color) => (
        <button
          key={color.id}
          type="button"
          aria-label={color.id}
          aria-pressed={selectedColor === color.value}
          onClick={(e) => {
            e.stopPropagation();
            onSelect(color.value);
          }}
          className={cn(
            'size-7 shrink-0 rounded-full transition-shadow focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 sm:size-8 sm:focus-visible:ring-offset-2',
            selectedColor === color.value &&
              'ring-2 ring-[#4F4F4F] ring-offset-1 dark:ring-true-white sm:ring-offset-2'
          )}
          style={{ backgroundColor: color.value }}
        />
      ))}
    </div>
  );
}
